/**
 * useAdminAuth - Shared admin authentication hook
 * Used by all /admin/* pages to share a single session.
 * Token is stored in localStorage so it persists across pages.
 */
import { useState } from 'react';

const STORAGE_KEY = 'admin_token';

export function useAdminAuth() {
  const [token, setToken] = useState(() => localStorage.getItem(STORAGE_KEY) || '');
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => !!localStorage.getItem(STORAGE_KEY)
  );

  const login = async (password) => {
    const response = await fetch('/api/admin/verify-token', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password }),
    });
    if (!response.ok) throw new Error('Invalid password');
    const data = await response.json();
    localStorage.setItem(STORAGE_KEY, data.token);
    setToken(data.token);
    setIsAuthenticated(true);
    return data.token;
  };

  const logout = () => {
    localStorage.removeItem(STORAGE_KEY);
    setToken('');
    setIsAuthenticated(false);
  };

  return { isAuthenticated, token, login, logout };
}
